import { useState } from 'react';
import type { MeetingStatus } from '@jabberr/core';
import { errorMessage } from '../lib/api.js';
import { ConfirmDialog } from './ui.js';

/** Hosts can clean up a live call without reconnecting their microphone. */
export function EndCallControl({ canEnd, status, onEnd }: {
  canEnd: boolean;
  status: MeetingStatus | undefined;
  onEnd: () => Promise<void>;
}) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!canEnd || status !== 'live') return null;
  const end = async () => {
    if (busy) return;
    setBusy(true); setError(null);
    try { await onEnd(); setConfirming(false); }
    catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  };
  return <>
    <button type="button" className="btn btn-secondary" disabled={busy} onClick={() => setConfirming(true)}>End call for everyone</button>
    {error && !confirming && <p role="alert">{error}</p>}
    {confirming && <ConfirmDialog title="End this call?" body={<><p>This ends the call for everyone, stops Professional voice and saves its transcript. Your microphone stays off.</p>{error && <p role="alert">{error}</p>}</>} confirmLabel="End call" busy={busy} onCancel={() => { if (!busy) setConfirming(false); }} onConfirm={() => void end()} />}
  </>;
}
